import { mergeOverrides } from 'baseui';
import { borderColor, borderRadius, borderStyle, borderWidth } from '../../Utilities/utils/Theming';
import { overrides as dropdownOverrides } from './overridesDropdown';
import { overridesInput } from './overridesInput';
import { IDummyProps } from './types';

export const overrides = (
	props: IDummyProps,
	css,
	mountNodeRef,
	combinedRef,
	dataProps: any,
	dataAria: any,
	noDataAriaProps: any,
	IOverrides: any,
	flagOverrides: any,
) => {
	const InputOverrides = IOverrides
		? mergeOverrides(
				overridesInput(props as any, dataProps, dataAria, noDataAriaProps) as any,
				IOverrides?.props?.overrides as any,
		  )
		: overridesInput(props as any, dataProps, dataAria, noDataAriaProps);

	return {
		Input: {
			props: {
				overrides: InputOverrides,
			},
		},
		CountrySelect: {
			props: {
				overrides: {
					...dropdownOverrides(
						props,
						!!props.positive,
						!!props.warning,
						'search',
						css,
						mountNodeRef,
						combinedRef,
					),
				},
			},
		},
		CountrySelectDropdownListItem: {
			props: {
				'data-epo': `epo-country-select-dropdown-item`,
				'data-testid': `epo-country-select-dropdown-item`,
			},
			style: ({ children }) => {
				return {
					...optionContentStyle(
						props.size,
						children?.props?.children?.props?.$selected,
						children?.props?.children?.props?.$isHighlighted,
					),
					':hover': {
						...borderColor('var(--epods--color-border-active)'),
					},
				};
			},
		},
		DialCode: {
			style: {
				color: 'var(--epods--color-text-primary)',
			},
		},
		...flagOverrides,
	};
};

const optionContentStyle = (size = 'default', selected: boolean, highlighted: boolean) => {
	return {
		height: 'auto',
		minHeight: `var(--epods--list-item-${size}-height)`,
		display: 'flex',
		alignContent: 'center',
		backgroundColor: selected ? 'var(--epods--color-bg-active)' : 'transparent',
		fontWeight: '100',
		fontSize: `var(--epods--dropdown-${size}-font-size)`,
		color: 'var(--epods--color-text-primary)',
		...borderWidth('var(--epods--border-width)'),
		...borderStyle('solid'),
		...borderColor(highlighted ? 'var(--epods--color-border-active)' : 'transparent'),
		...borderRadius('var(--epods--border-radius)'),
		span: {
			fontFamily: 'inherit',
		},
	};
};
